import {
  createFetchWithTimeout,
  ENDPOINT_OSS_API,
  ENDPOINT_OSS_API_TIMEOUT,
} from '../utils';

import type { CreateClientConfig } from '../generated/uis/client.gen';

export const createClientConfig: CreateClientConfig = config => ({
  ...config,
  baseUrl: ENDPOINT_OSS_API,
  fetch: createFetchWithTimeout(ENDPOINT_OSS_API_TIMEOUT),
});
